// Инпут, лэйбл и вывод ошибок для поля формы

const template = `
    <div class="form-group form-group--withhelp">
        <label v-if="label" class="form-label" :for="id">[[ label ]]</label>
        <input
            :class="[inputClass, errorClass]"
            :id="id"
            :type="inputType"
            :name="name"
            :data-suggest="suggest"
            :data-focused="isFocused"
            :value="inputValue"
            :ref="isFocused ? 'input' : null"
            @change="handleChange"
            @keyup.escape.stop="$event.target.blur()"
        />
        <div v-if="!error" class="form-helptext">[[ helptext ]]</div>
        <transition name="slide-in">
            <div v-if="error" class="form-helptext form-helptext--error">[[ error ]]</div>
        </transition>
    </div>`;

const props = {
    inputName: String,
    inputType: {
        type: String,
        default: "text",
    },
    inputClass: String,
    label: String,
    formName: String,
    helptext: String,
    errors: { type: Array },
    isFocused: {
        default: false,
        type: Boolean,
    },
    suggest: String,
    value: {
        type: String,
        default: "",
    },
};

const computed = {
    inputNameFinal() {
        return this.inputName || this.inputType;
    },
    name() {
        return this.formName ? `${this.formName}-${this.inputNameFinal}` : this.inputNameFinal;
    },
    id() {
        return `id_${this.name}`;
    },
    error() {
        return this.visibleErrors?.join(", ");
    },
    errorClass() {
        return this.error ? "error" : "";
    },
};

const emits = ["inputChanged"];

export default {
    props,
    template,
    computed,
    emits,
    data() {
        return {
            visibleErrors: this.errors,
            inputValue: this.value,
        };
    },
    watch: {
        errors(newVal) {
            this.visibleErrors = newVal;
        },
        shouldFocus(newVal) {
            if (!newVal) return;
            this.$nextTick(() => {
                this.$refs.input?.focus();
            });
        },
        value(newVal) {
            this.inputValue = newVal;
        },
    },
    methods: {
        handleChange(e) {
            this.visibleErrors = null;
            this.inputValue = e.target.value;
            this.$emit("inputChanged", e.target.value);
        },
    },
    inject: ["shouldFocus"],
    name: "FormGroup",
};
